import React from 'react';
import Image from 'next/image';

import styles from './testimonial.module.scss';
import {useViewport, withinOrWiderThan} from '@udemy-v2/react-layout-components';

interface TestimonialProps {
    quote: string;
    avatarImg: string;
    author: string;
    fullHeight?: boolean;
}
export const Testimonial: React.FC<TestimonialProps> = ({
    quote,
    avatarImg,
    author,
    fullHeight = false,
}) => {
    const {range} = useViewport();
    const isWideViewport = range && withinOrWiderThan(range, 'md');
    const imageSquaredSize = isWideViewport ? 85 : 55;
    return (
        <div
            className={`${styles['testimonial-container']} ${fullHeight ? styles['testimonial-full-height'] : ''}`}
        >
            <p className={styles['testimonial-description']}>{quote}</p>
            <div className={styles['testimonial-author']}>
                <div className={styles['testimonial-author-icons']}>
                    <Image
                        className={styles['quote-circle']}
                        src={
                            'https://frontends.udemycdn.com/frontends-landing-pages/60-day-hustle/images/social-proof/60-day-hustle-quote-logo.svg'
                        }
                        width={imageSquaredSize}
                        height={imageSquaredSize}
                        alt=""
                        data-testid="quote-image"
                    />
                    <Image
                        className={styles['avatar-main']}
                        src={avatarImg}
                        width={imageSquaredSize}
                        height={imageSquaredSize}
                        alt="Author's avatar"
                        data-testid="avatar-image"
                    />
                </div>
                <address>{author}</address>
            </div>
        </div>
    );
};
